import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientCharacteristics(id: string | undefined) {
  return useQuery(queries.patients.getPatientLatestCharacteristics(id || ''))
}
